<template>
    <div class="bg-white shadow rounded px-3 pb-5 border border-white mb-3 last:mb-0">
        <div class="absolute mr-4 mt-1 right-0">
            <vs-dropdown vs-trigger-click class="cursor-pointer">
                <small class="flex cursor-pointer">
                    <svg xmlns="http://www.w3.org/2000/svg"
                         xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" version="1.1" id="Capa_1"
                         width="16px"
                         height="16px"
                         viewBox="0 0 990.9 990.9" xml:space="preserve">
      <g>
        <path
            d="M144.2,639.6c79.6,0,144.1-64.5,144.1-144.1c0-79.601-64.5-144.1-144.1-144.1C64.5,351.3,0,415.8,0,495.4   C0,575,64.5,639.6,144.2,639.6z M144.2,425.9c38.3,0,69.5,31.2,69.5,69.5c0,38.301-31.2,69.5-69.5,69.5   c-38.3,0-69.5-31.199-69.5-69.5C74.7,457.1,105.8,425.9,144.2,425.9z"/>
          <path
              d="M351.4,495.4C351.4,575,415.9,639.5,495.5,639.5S639.6,575,639.6,495.4c0-79.6-64.5-144.1-144.1-144.1   S351.4,415.8,351.4,495.4z M565,495.4c0,38.301-31.2,69.5-69.5,69.5S426,533.701,426,495.4c0-38.3,31.2-69.5,69.5-69.5   S565,457.1,565,495.4z"/>
          <path
              d="M846.8,351.3c-79.6,0-144.1,64.5-144.1,144.1C702.7,575,767.2,639.5,846.8,639.5C926.4,639.5,990.9,575,990.9,495.4   C991,415.8,926.5,351.3,846.8,351.3z M846.8,564.9c-38.3,0-69.5-31.199-69.5-69.5c0-38.3,31.2-69.5,69.5-69.5s69.5,31.2,69.5,69.5   C916.3,533.701,885.2,564.9,846.8,564.9z"/>
      </g>
    </svg>
                </small>
                <vs-dropdown-menu class="w-32">
                    <vs-dropdown-item @click="openUpdates">
                        <div class="flex items-center py-2 gap-2">
                            <feather-icon svg-classes="h-4 w-4" icon="EyeIcon" color="primary"></feather-icon>
                            <h6>Chi tiết</h6>
                        </div>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="confirmDeleteTask"
                                      v-if="isPermissionDelete()">
                        <div class="flex items-center py-2 gap-2">
                            <feather-icon svg-classes="h-4 w-4" icon="Trash2Icon" color="danger"
                            ></feather-icon>
                            <h6>Xóa</h6>
                        </div>
                    </vs-dropdown-item>
                </vs-dropdown-menu>
            </vs-dropdown>
        </div>

        <div class="mt-6 justify-between items-center">
            <vx-tooltip class="flex items-center" :text="task.title">
                <h4
                    style="text-overflow: ellipsis ; overflow: hidden; white-space: nowrap; font-size: 12px; position: relative;">
                    {{ task.title }}</h4>
            </vx-tooltip>
            <div class="flex items-center mt-2">
                <vx-tooltip class="flex items-center" :text="task.parentTask.title" v-if="task.parentTask">
                    <vs-chip color="primary">
                        <feather-icon svg-classes="h-4 w-4" icon="GitMergeIcon"></feather-icon>
                    </vs-chip>
                </vx-tooltip>
                <vs-chip :color="task.priorityColor" class="mt-1 mr-2">
                    <span>{{ task.priorityTitle }}</span>
                </vs-chip>
                <div v-for="(user, ind) in task.listUser" :key="ind">
                    <vx-tooltip class="flex" color="primary" :text="user.fullName">
                        <img class="w-6 h-6 rounded-full" :src="user.avatar" alt="" v-if="user.avatar">
                        <img src="@/assets/images/portrait/small/user-avatar.png"
                             alt=""
                             class="w-6 h-6 rounded-full" v-else>
                    </vx-tooltip>
                </div>
            </div>
            <div class="flex item-center mt-2">
                <vs-chip v-for="(label, ind) in task.taskLabel" :key="ind" :color="label.color">
                    <span>{{ label.label }}</span>
                </vs-chip>
            </div>
        </div>
        <div class="mt-4"
             :class="(timestampToDate(task.endTime) < timestampToDate(currentDate) && task.status !== 2) ? 'text-danger' : ''">
            <span class="text-sm text-gray-600"> {{ task.startTimeCvt + ' - ' + task.endTimeCvt }} </span>
        </div>
        <vs-divider class="my-2"></vs-divider>

        <div class="flex items-center">
            <vx-tooltip text="Comments" class="flex items-center">
                <feather-icon svg-classes="h-4 w-4" icon="MessageCircleIcon"
                              @click="showPopupCommentTask"></feather-icon>
            </vx-tooltip>
            <p class="text-gray-700 font-semibold font-sans tracking-wide text-sm ml-2 mr-6">
                {{ task.responseCount ? task.responseCount : 0 }}</p>
            <vx-tooltip text="Subtasks" class="flex items-center">
                <feather-icon svg-classes="h-4 w-4" icon="GitBranchIcon" @click="showPopupSubTask"></feather-icon>
            </vx-tooltip>
            <p class="text-gray-700 font-semibold font-sans tracking-wide text-sm ml-2">
                {{ task.childTasks ? task.childTasks.length : 0 }}</p>
            <vx-tooltip text="Checklist" v-if="task.taskChecklistsTotal > 0" class="ml-6">
                <vs-chip color="primary">
                    <feather-icon svg-classes="h-4 w-4 mr-2" icon="CheckIcon"></feather-icon>
                    {{ task.taskChecklistsDone + '/' + task.taskChecklistsTotal }}
                </vs-chip>
            </vx-tooltip>
        </div>

        <vs-popup :title="$t('tasks.update')" :active.sync="popupUpdate" :button-close-hidden="true" v-if="popupUpdate"
                  id="popup-update-task">
            <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full">
                    <div class="vx-row">
                        <div class="vx-col md:w-full">
                            <label class="vs-input--label required">{{ $t('tasks.project') }}</label>
                            <vs-input disabled v-model="task.project.title" class="w-full" v-validate="'required'"/>
                        </div>
                        <div class="vx-col w-full mt-4">
                            <label class="vs-input--label required">{{ $t('tasks.title') }}</label><br/>
                            <vs-input v-model="task.title" class="w-full" v-validate="'required'" name="title"/>
                            <span class="text-danger text-sm">{{ errors.first('title') }}</span>
                        </div>
                        <div class="vx-col w-full mt-4">
                            <label class="vs-input--label">{{ $t('tasks.description') }}</label>
                            <vs-textarea class="w-full" v-model="task.description" v-validate="'required'"
                                         name="description"></vs-textarea>
                            <span class="text-danger text-sm">{{ errors.first('description') }}</span>
                        </div>
                        <div class="vx-col w-full mt-4">
                            <label class="vs-input--label required">{{ $t('tasks.status') }}</label>
                            <v-select class="w-full" v-model="selectedStatusTask" :clearable="false" :options="statusOptions"
                                      :reduce="(options) => options.value" v-validate="'required'" name="stt">
                            </v-select>
                            <span class="text-danger text-sm">{{ errors.first('stt') }}</span>
                        </div>
                        <div class="vx-col w-full mt-4">
                            <label class="vs-input--label">{{ $t('tasks.jobLabel') }}</label>
                            <v-select class="w-full" v-model="selectedLabel" :clearable="false"
                                      :options="taskLabel" multiple @input="changeSelectLabel">
                            </v-select>
                        </div>
                        <div class="vx-col w-full mt-4">
                            <label class="vs-input--label required">{{ $t('tasks.assignedPerson') }}</label><br/>
                            <v-select class="w-full" v-model="task.assigneeId" :clearable="false"
                                      :options="employeeOption"
                                      :reduce="(options) => options.value" @input="changSelecEmployee"
                                      :disabled="userInfo.userRole === 'user' && task.createdByEmployee && userInfo.employeeId !== task.createdByEmployee.employeeId">
                            </v-select>
                        </div>
                        <div class="flex vx-col w-full mt-4">
                            <div class="vx-col md:w-1/2">
                                <label class="vs-input--label required">{{ $t('tasks.startDate') }}</label>
                                <div class="w-full">
                                    <datepicker class="w-full" :language="vi" :format="'dd/MM/yyyy'"
                                                v-model="selectstartDate" data-vv-validate-on="input"
                                                ref="datepickBooking"
                                                v-validate="'required'"
                                                name="time">
                                    </datepicker>
                                    <span class="text-danger text-sm">{{ errors.first('time') }}</span>
                                </div>
                            </div>
                            <div class="vx-col md:w-1/2 ml-2">
                                <label class="vs-input--label required">{{ $t('tasks.hours') }}</label>
                                <div class="w-full">
                                    <flat-pickr :config="configTimePicker" v-model="selectStartTime"
                                                class="w-full vs-inputx vs-input--input normal" name="time"/>
                                </div>
                            </div>
                        </div>
                        <div class="flex vx-col w-full ">
                            <div class="vx-col md:w-1/2 w-1/2 mt-4">
                                <label class="vs-input--label required">{{ $t('tasks.endDate') }}</label>
                                <div class="w-full">
                                    <datepicker class="w-full" :language="vi" :format="'dd/MM/yyyy'"
                                                v-model="selectEndDate" data-vv-validate-on="input"
                                                ref="datepickBooking"
                                                v-validate="'required'"
                                                name="time">
                                    </datepicker>
                                    <span class="text-danger text-sm">{{ errors.first('time') }}</span>
                                </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-1/2 mt-4 ml-2">
                                <label class="vs-input--label required">{{ $t('tasks.hours') }}</label>
                                <div class="w-full">
                                    <flat-pickr :config="configTimePicker" v-model="selectEndTime"
                                                class="w-full vs-inputx vs-input--input normal" name="time"/>
                                </div>
                            </div>
                        </div>
                        <div class="vx-col w-full mt-4">
                            <label class="vs-input--label required">{{ $t('tasks.priority') }}</label><br/>
                            <v-select class="w-full" v-model="task.priority" :clearable="false"
                                      :options="priorityOptions"
                                      :reduce="(options) => options.value">
                            </v-select>
                        </div>
                        <div class="vx-col w-full mt-4" style="margin-top: 10px;">
                            <label class="vs-input--label">{{ $t('tasks.listOfAddedPeople') }}</label><br/>
                            <v-select class="w-full" v-model="selectedColloborators" :clearable="false"
                                      :options="collaboratorsOption"
                                      multiple @input="changeColloborator">
                            </v-select>
                        </div>
                    </div>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                    <div class="vx-row">
                        <div class="vx-col w-full">
                            <h4>Checklist</h4>
                            <div class="checklist-task">
                                <VuePerfectScrollbar ref="mainSidebarPs"
                                                     class="scroll-area--checklist-task w-full"
                                                     :settings="settings" :key="$vs.rtl">
                                    <draggable
                                        :list="task.taskChecklists"
                                        class="list-group"
                                        v-bind="dragOptions"
                                        @start="drag = true"
                                        @end="endDrag"
                                        :disabled="task.status === 3 || !isPermissionUpdate()"
                                    >
                                        <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                                            <div class="w-full px-4 mt-2" v-for="(list, ind) in task.taskChecklists"
                                                 :key="ind">
                                                <div class="w-full flex p-2 item-select items-center">
                                                    <vs-checkbox v-model="list.check" @input="tickChecklist(list, ind)"
                                                                 :disabled="task.status === 3 || !isPermissionUpdate()"></vs-checkbox>
                                                    <span>{{ list.title }}</span>
                                                    <vx-tooltip :text="$t('button.delete')" class="flex ml-auto"
                                                                v-if="task.status !== 3 && isPermissionUpdate()">
                                                        <feather-icon svg-classes="h-4 w-4" icon="XIcon"
                                                                      class="text-danger"
                                                                      @click="deleteChecklist(list, ind)"></feather-icon>
                                                    </vx-tooltip>
                                                </div>
                                            </div>
                                        </transition-group>
                                    </draggable>
                                </VuePerfectScrollbar>
                            </div>
                            <div class="create-checklist-task mt-4"
                                 v-if="isPermissionUpdate()">
                                <div class="vx-row">
                                    <div class="vx-col w-full" v-if="isCreateChecklist">
                                        <vs-input class="w-full" v-model="checklistTitle"
                                                  placeholder="Thêm danh mục công việc ..."
                                                  @keydown.enter="createChecklistTask"></vs-input>
                                    </div>
                                    <div class="vx-col w-full mt-2" v-if="!isCreateChecklist">
                                        <vs-button icon-pack="feather" icon="icon-plus" type="border"
                                                   @click="isCreateChecklist = true">{{ $t('button.add') }}
                                        </vs-button>
                                    </div>
                                    <div class="vx-col w-full mt-2 flex gap-2" v-else>
                                        <vs-button icon-pack="feather" icon="icon-check" type="border"
                                                   @click="createChecklistTask">{{ $t('button.save') }}
                                        </vs-button>
                                        <vs-button icon-pack="feather" icon="icon-x" type="border" color="danger"
                                                   @click="cancelCreateChecklist">{{ $t('button.cancel') }}
                                        </vs-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="vx-col w-full" v-if="task.childTasks && task.childTasks.length > 0">
                            <vs-divider></vs-divider>
                            <h4>Subtask</h4>
                            <div class="w-full mt-2" v-for="(sub, ind) in task.childTasks" :key="ind">
                                <div class="sub-task flex justify-between items-center p-2">
                                    <span class="text-md font-semibold">{{ sub.title }}</span>
                                    <vs-chip :color="chipColorStatus(sub.status)" class="mr-2">
                                        <span>{{ stringStatus(sub.status) }}</span>
                                    </vs-chip>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="vx-row">
                <div class="vx-col w-full" style="margin-top: 10px;">
                    <div class="mt-2 flex flex-wrap items-center justify-end mb-2">
                        <vs-button class="mr-4" @click="saveUpdateTask" icon-pack="feather" icon="icon-plus"
                                   :disabled="!isPermissionUpdate()">
                            {{ $t('tasks.update') }}
                        </vs-button>
                        <vs-button color="danger" type="border" icon-pack="feather" icon="icon-x"
                                   @click="closePopup">{{ $t('tasks.close') }}
                        </vs-button>
                    </div>
                </div>
            </div>
        </vs-popup>

        <vs-popup :title="task.title" :active.sync="popupCommentTask" :button-close-hidden="true"
                  v-if="popupCommentTask" id="popup-comment-task">
            <div class="vx-row">
                <div class="vx-col md:w-2/3 w-full">
                    <div class="vx-row">
                        <div class="vx-col w-full">
                            <span>Project: </span>
                            <span class="text-primary">{{ task.project.title }}</span>
                        </div>
                    </div>
                    <vs-divider></vs-divider>
                    <div class="vx-row" v-if="userInfo.userRole === 'user'">
                        <div class="vx-col w-1/4">
                            <vs-avatar size="100px" :src="userInfo.avatar" v-if="userInfo.avatar"/>
                            <vs-avatar size="100px"
                                       src="@/assets/images/portrait/small/user-avatar.png"
                                       v-else/>
                        </div>
                        <div class="vx-col w-3/4 pl-0">
                            <div class="vx-row">
                                <div class="vx-col w-full">
                                    <vs-textarea :placeholder="$t('tasks.writeAComment')" v-model="taskContent"/>
                                </div>
                                <VuePerfectScrollbar ref="mainSidebarPs" class="scroll--list-file-upload vx-col w-full"
                                                     :settings="settings"
                                                     :key="$vs.rtl">
                                    <div class="flex items-center flex-wrap" v-if="fileCmt.length > 0">
                                        <div v-for="(file, index) in fileCmt" :key="index">
                                            <div class="text-center -mb-2">
                                                <vx-tooltip :text="$t('button.delete')">
                                                    <feather-icon icon="XCircleIcon" svgClasses="h-4 w-4 text-danger"
                                                                  @click="deleteFile(index)"/>
                                                </vx-tooltip>
                                            </div>
                                            <vx-tooltip :text="file.name" position="top">
                                                <feather-icon icon="FileTextIcon" svgClasses="h-12 w-12"/>
                                            </vx-tooltip>
                                        </div>
                                    </div>
                                </VuePerfectScrollbar>
                                <div class="vx-col w-full flex justify-between mt-4">
                                    <vs-button size="small" icon-pack="feather" icon="icon-upload-cloud" type="border"
                                               @click="$refs.fileCmt.click()">{{ $t('tasks.addFiles') }}
                                    </vs-button>
                                    <vs-button size="small" icon-pack="feather" icon="icon-send" @click="postComment">
                                        {{ $t('tasks.postComment') }}
                                    </vs-button>
                                </div>
                                <input ref="fileCmt" type="file" id="imageUpload" multiple
                                       class="hidden" @change="uploadFileCmt()">
                            </div>
                        </div>
                    </div>
                    <div class="vx-row mt-6" v-if="dataCommentTask.length > 0">
                        <VuePerfectScrollbar ref="mainSidebarPs" class="scroll--list-comment-task vx-col w-full"
                                             :settings="settings" @ps-scroll-y="handleScrollComment"
                                             :key="$vs.rtl">
                            <div class="vx-row" v-for="(cmt, index) in dataCommentTask" :key="index">
                                <div class="vx-col w-full">
                                    <vs-divider class="m-1"></vs-divider>
                                </div>
                                <div class="vx-col w-full flex gap-2">
                                    <img :src="cmt.employee.avatar" width="40px" height="40px" class="rounded-full" v-if="cmt.employee.avatar"/>
                                    <img
                                        src="@/assets/images/portrait/small/user-avatar.png"
                                        width="40px" height="40px" class="rounded-full" v-else/>
                                    <div class="vx-row">
                                        <div class="vx-col w-full">
                                            <span class="text-md font-semibold">{{ cmt.employee.fullName }}</span>
                                            <span class="text-sm ml-1">{{ cmt.createdDateStr }}</span>
                                        </div>
                                        <div class="vx-col w-full">
                                            <span class="text-md">{{ cmt.content }}</span>
                                        </div>
                                        <VuePerfectScrollbar ref="mainSidebarPs"
                                                             class="scroll--list-file-upload vx-col w-full"
                                                             :settings="settings"
                                                             :key="$vs.rtl" v-if="cmt.fileManagers.length > 0">
                                            <div class="flex items-center flex-wrap">
                                                <div v-for="(file, index) in cmt.fileManagers" :key="index">
                                                    <vx-tooltip :text="file.metaData.name" position="top">
                                                        <feather-icon icon="FileTextIcon" svgClasses="h-6 w-6"
                                                                      @click="openFile(file)"/>
                                                    </vx-tooltip>
                                                </div>
                                            </div>
                                        </VuePerfectScrollbar>
                                    </div>
                                    <div class="absolute right-0 mr-4"
                                         v-if="userInfo.userRole === 'user' && userInfo.employeeId === cmt.employee.employeeId">
                                        <vx-tooltip :text="$t('button.delete')">
                                            <feather-icon svg-classes="h-4 w-4" icon="Trash2Icon" class="text-danger"
                                                          @click="confirmDeleteCmt(cmt, index)"></feather-icon>
                                        </vx-tooltip>
                                    </div>
                                </div>
                            </div>
                        </VuePerfectScrollbar>
                    </div>
                </div>
                <div class="vx-col md:w-1/3 w-full">
                    <div class="vx-row">
                        <div class="vx-col w-full flex items-center gap-2">
                            <div>
                                <vs-avatar size="70px" :src="task.assignEmployee.avatar"
                                           v-if="task.assignEmployee.avatar"/>
                                <vs-avatar size="70px"
                                           src="@/assets/images/portrait/small/user-avatar.png"
                                           v-else/>
                            </div>
                            <div>
                                <span class="font-semibold">{{ task.assignEmployee.fullName }}</span>
                                <div>
                                    <vs-chip :color="chipColorStatus(task.status)">
                                        <span>{{ stringStatus(task.status) }}</span>
                                    </vs-chip>
                                </div>
                            </div>
                        </div>
                        <div class="vx-col w-full mt-2">
                            <span class="font-semibold">Start date: </span>
                            <span class="text-primary">{{ task.startTimeCvt }}</span>
                        </div>
                        <div class="vx-col w-full mt-2">
                            <span class="font-semibold">Deadline: </span>
                            <span class="text-primary">{{ task.endTimeCvt }}</span>
                        </div>
                        <div class="vx-col w-full mt-2 flex items-center gap-2">
                            <span class="font-semibold">Priority: </span>
                            <vs-chip :color="task.priorityColor">
                                <span>{{ task.priorityTitle }}</span>
                            </vs-chip>
                        </div>
                        <div class="vx-col w-full mt-2" v-if="task.collaborateEmployees.length > 0">
                            <p class="font-semibold">Collaborators: </p>
                            <div class="flex">
                                <div v-for="(img, ind) in task.collaborateEmployees" :key="ind">
                                    <vs-avatar size="" :src="img.avatar" v-if="img.avatar"/>
                                    <vs-avatar size=""
                                               src="@/assets/images/portrait/small/user-avatar.png"
                                               v-else/>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="vx-row mt-4">
                        <div class="vx-col w-full text-center">
                            <vs-divider></vs-divider>
                            <span class="font-semibold">{{ $t('tasks.recentActivity') }}</span>
                        </div>
                        <VuePerfectScrollbar class="scroll-area--task-his mt-4 w-full" :settings="settings"
                                             :key="$vs.rtl"
                                             ref="scrollBar" @ps-scroll-y="handleScrollActivity"
                                             v-if="taskLogHistory.length > 0">
                            <div v-for="(data, ind) in taskLogHistory " :key="ind">
                                <div class="flex gap-2 mt-6">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="24"
                                         viewBox="0 0 23 24"
                                         fill="none">
                                        <rect x="2.94628" y="11.9706" width="11.8333" height="11.8333"
                                              transform="rotate(-45 2.94628 11.9706)"
                                              :stroke=" data.type === 1 ? 'rgba(var(--vs-primary), 1)' : 'rgba(var(--vs-warning), 1)'"
                                              stroke-width="1.5"/>
                                    </svg>
                                    <div class="w-full">
                                        <div class="flex">
                                            <p class="font-semibold" v-if="data.type === 1">{{
                                                    data.metaData.createdBy
                                                }}</p>
                                            <p class="font-semibold" v-if="data.type === 2">{{ data.createdBy }}</p>
                                            <p v-if="data.type === 1" class="ml-4">{{
                                                    data.startTimeAct
                                                }}</p>
                                        </div>
                                        <div class="flex items-center mt-1">
                                            <vs-chip :color="chipColor(data.type)" v-if="data.type">{{
                                                    data.type === 1 ?
                                                        'Thêm mới' : 'Cập nhật'
                                                }}
                                            </vs-chip>
                                            <p class="ml-4 font-semibold" style="width: 70%">
                                                {{ data.metaData.title }}
                                            </p>
                                        </div>
                                        <div>
                                            <p v-if="data.type === 2 && data.metaData.newTitle">Title:
                                                <span class="mr-2 text-danger line-through">
                                                        <span>{{ data.metaData.oldTitle }}</span>
                                                    </span>
                                                <span class="text-primary">{{
                                                        data.metaData.newTitle
                                                    }}</span></p>
                                            <p v-if="data.type === 2 && data.oldStartTimeAct !== data.newEndTimeAct">
                                                Start Time:
                                                <span class="mr-2 text-danger line-through">
                                                        <span>{{ data.oldStartTimeAct }}</span>
                                                    </span>
                                                - <span class="text-primary">{{ data.newStartTimeAct }}</span></p>
                                            <p v-if="data.type === 2 && data.oldEndTimeAct !== data.newEndTimeAct">
                                                End
                                                Time:
                                                <span class="mr-2 text-danger line-through">
                                                        <span>{{ data.oldEndTimeAct }}</span>
                                                    </span>
                                                -
                                                <span class="text-primary">{{ data.newEndTimeAct }}</span>
                                            </p>
                                            <p v-if="data.type === 2 && data.metaData.newPriority">
                                                Priority:
                                                <del style="margin-right: 5px;"> {{
                                                        data.metaData.oldPriority
                                                    }}
                                                </del>
                                                <span style="color:#00b393">{{ data.metaData.newPriority }}
                                        </span>
                                            </p>
                                            <p v-if="data.type === 2 && data.metaData.newStatus">Status:
                                                <span class="mr-2 text-danger line-through">
                                                        <span class="status-color" :title="data.metaData.oldStatus">{{
                                                                data.metaData.oldStatus
                                                            }}</span>
                                                    </span>
                                                <span class="status-color" :title="data.metaData.newStatus">{{
                                                        data.metaData.newStatus
                                                    }}</span>
                                            </p>
                                            <p v-if="data.type === 2 && data.metaData.newAssignee">
                                                Assignee:
                                                <del style="margin-right: 5px;"> {{
                                                        data.metaData.oldAssignee
                                                    }}
                                                </del>
                                                <span style="color:#00b393">{{
                                                        data.metaData.newAssignee
                                                    }}</span></p>
                                            <p v-if="data.type === 2 && data.metaData.newCollaborators">
                                                Collaborators:
                                                <del style="margin-right: 5px;"> {{
                                                        data.metaData.oldCollaborators
                                                    }}
                                                </del>
                                                {{
                                                    data.metaData.newCollaborators
                                                }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </VuePerfectScrollbar>
                    </div>
                </div>
                <div class="vx-col w-full mt-6">
                    <vs-button color="warning" type="border" icon-pack="feather" icon="icon-x" class="float-right mt-2"
                               @click="closePopup">{{ $t('tasks.close') }}
                    </vs-button>
                </div>
            </div>
        </vs-popup>

        <vs-popup :title="'Sub ' + task.title" :active.sync="popupSubTask" :button-close-hidden="true"
                  v-if="popupSubTask" id="popup-sub-task">
            <div class="vx-row">
                <div class="vx-col w-full" v-if="task.childTasks && task.childTasks.length > 0">
                    <div class="vx-row">
                        <div class="vx-col w-full mt-2" v-for="(sub, ind) in task.childTasks" :key="ind">
                            <div class="sub-task flex justify-between items-center p-2">
                                <span class="text-md font-semibold">{{ sub.title }}</span>
                                <vs-chip :color="chipColorStatus(sub.status)" class="mr-2">
                                    <span>{{ stringStatus(sub.status) }}</span>
                                </vs-chip>
                            </div>
                        </div>
                    </div>
                    <vs-divider></vs-divider>
                </div>
                <div class="vx-col w-full" v-else>
                    <div class="flex justify-center">
                        <span>Không có dữ liệu!</span>
                    </div>
                    <vs-divider></vs-divider>
                </div>
                <div class="vx-col w-full mt-4"
                     v-if="isPermissionUpdate()">
                    <div class="vx-row" v-if="!isAddSubtask">
                        <div class="vx-col w-full">
                            <vs-button icon-pack="feather" icon="icon-plus" color="primary" type="border"
                                       @click="isAddSubtask = true">
                                {{ $t('button.add') }}
                            </vs-button>
                        </div>
                    </div>
                    <div class="vx-row" v-else>
                        <div class="vx-col w-full">
                            <vs-input class="w-full" v-model="subTaskTitle"
                                      placeholder="Tạo mới nhiệm vụ phụ"></vs-input>
                        </div>
                        <div class="vx-col w-full mt-4 flex gap-4">
                            <vs-button icon-pack="feather" icon="icon-plus" color="primary" @click="saveSubTask">
                                {{ $t('button.create') }}
                            </vs-button>
                            <vs-button icon-pack="feather" icon="icon-x" color="danger" @click="cancelAddSubtask">
                                {{ $t('button.cancel') }}
                            </vs-button>
                        </div>
                    </div>
                </div>
                <div class="vx-col w-full">
                    <vs-button color="warning" type="border" icon-pack="feather" icon="icon-x" class="float-right mt-4"
                               @click="closePopup">{{ $t('tasks.close') }}
                    </vs-button>
                </div>
            </div>
        </vs-popup>

    </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import Badge from "./Badge.vue"
import {AgGridVue} from "ag-grid-vue"
import vSelect from 'vue-select'
import Multiselect from 'vue-multiselect'
import DateRangePicker from '../../../components/vue2-daterange-picker/components/DateRangePicker.vue'
import Datepicker from 'vuejs-datepicker'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import {vi} from 'vuejs-datepicker/dist/locale'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import moment from "moment"
// import 'quill/dist/quill.snow.css'
// import {quillEditor} from 'vue-quill-editor'
import draggable from "vuedraggable"

export default {
    components: {
        Badge,
        vSelect,
        DateRangePicker,
        AgGridVue,
        Multiselect,
        Datepicker,
        flatPickr,
        VuePerfectScrollbar,
        // quillEditor,
        draggable,
    },
    data() {
        return {
            vi: vi,
            popupUpdate: false,
            isDisabled: false,
            showTaskInfo: false,
            collaboratorsOption: [],
            statusOptions: [
                {
                    value: 0,
                    label: 'To do'
                },
                {
                    value: 1,
                    label: 'Doing'
                },
                {
                    value: 2,
                    label: 'Completed'
                },
                {
                    value: 3,
                    label: 'Canceled'
                }
            ],
            startDateAddRange: {
                startDate: new Date(),
                endDate: new Date(),
            },
            configTimePicker: {
                enableTime: true,
                noCalendar: true,
                dateFormat: "H:i",
                time_24hr: true,
                minTime: "07:00",
            },
            selectstartDate: null,
            selectStartTime: null,
            selectEndDate: null,
            selectEndTime: null,
            currentDate: new Date(),
            employeeOption: [],
            selectedColloborators: [],
            userInfo: JSON.parse(localStorage.getItem('userInfo')),
            popupCommentTask: false,
            taskContent: null,
            fileCmt: [],
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: .60,
            },
            pageNumberCmt: 0,
            pageSizeCmt: 10,
            dataCommentTask: [],
            pageNumberHis: 0,
            taskLogHistory: [],
            disableScrollHis: false,
            disableScrollCmt: false,
            popupSubTask: false,
            subTaskTitle: null,
            checklistTitle: null,
            isCreateChecklist: false,
            drag: false,
            isAddSubtask: false,
            selectedLabel: [],
            selectedStatusTask: null,
        }
    },
    props: {
        task: {
            type: Object,
            default: () => ({})
        },
        taskLabel: {
            type: Array
        },
        priorityOptions: {
            type: Array
        }
    },
    methods: {
        isPermissionUpdate() {
            if (this.task.status === 2 || this.task.status === 3) {
                return false
            } else {
                if (this.userInfo.userRole === 'user') {
                    if (this.task.assigneeId === this.userInfo.employeeId) return true
                    if (this.task.createdByEmployee && this.task.createdByEmployee.employeeId === this.userInfo.employeeId) return true
                    if (this.userInfo.employeeId === this.task.project.responsibleEmployee.employeeId) return true
                    return false
                } else if (this.userInfo.userRole === 'organization') {
                    return true
                }
            }
        },

        isPermissionDelete() {
            if (this.userInfo.userRole === 'user') {
                if (this.task.createdByEmployee && this.task.createdByEmployee.employeeId === this.userInfo.employeeId) return true
                if (this.userInfo.employeeId === this.task.project.responsibleEmployee.employeeId) return true
                return false
            } else if (this.userInfo.userRole === 'organization') {
                return true
            }
        },

        timestampToDate(timestamp) {
            return new Date(timestamp).getTime();
        },
        changSelecEmployee() {
            this.collaboratorsOption = this.employeeOption.filter(el => el.value !== this.task.assigneeId)
        },

        changeSelectLabel() {
            this.task.labels = [];
            this.selectedLabel.forEach(el => {
                this.task.labels.push(el.label);
            })
        },
        dateRangePicker() {
            this.dateRange.startDate = new Date(this.dateRange.startDate);
            this.dateRange.endDate = new Date(this.dateRange.endDate);
        },
        async saveUpdateTask() {
            const hours = parseInt(this.selectStartTime.split(':')[0]);
            const minutes = parseInt(this.selectStartTime.split(':')[1]);
            this.selectstartDate = new Date(this.selectstartDate)
            this.selectstartDate.setHours(hours);
            this.selectstartDate.setMinutes(minutes);

            const hoursEnd = parseInt(this.selectEndTime.split(':')[0]);
            const minutesEnd = parseInt(this.selectEndTime.split(':')[1]);
            this.selectEndDate = new Date(this.selectEndDate)
            this.selectEndDate.setHours(hoursEnd);
            this.selectEndDate.setMinutes(minutesEnd);
            let collaborators = []
            if (this.selectedColloborators.length > 0) collaborators = this.selectedColloborators.map(el => el.value)
            let body = {
                title: this.task.title,
                description: this.task.description,
                status: this.selectedStatusTask,
                startTime: new Date(this.selectstartDate).toISOString(),
                endTime: new Date(this.selectEndDate).toISOString(),
                assigneeId: this.task.assigneeId,
                priority: this.task.priority,
                projectId: this.task.project.id,
                collaborators: collaborators,
                labels: this.task.labels
            }
            this.$vs.loading();
            this.$crm.post(`/task/update/${this.task.id}`, body).then(() => {
                this.$vs.loading.close();
                this.$vs.notify({
                    color: 'success',
                    text: `Cập nhật thành công`,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
                this.popupUpdate = false;
                this.$store.commit('UPDATE_TASK_KANBAN', true);
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',

                });

            })
        },

        async openUpdates() {
            await this.getEmployee()
            this.selectstartDate = this.task.startTime
            this.selectStartTime = new Date(this.task.startTime).getHours() + ':' + new Date(this.task.startTime).getMinutes() + ':' + new Date(this.task.startTime).getSeconds()
            this.selectEndDate = this.task.endTime
            this.selectEndTime = new Date(this.task.endTime).getHours() + ':' + new Date(this.task.endTime).getMinutes() + ':' + new Date(this.task.endTime).getSeconds()
            // this.selectEndTime = new Date(this.task.endTime).getMinutes()
            if (this.task.assigneeId) this.changSelecEmployee()
            if (this.task.collaborators.length > 0) {
                this.selectedColloborators = []
                this.task.collaborators.forEach(el => {
                    let result = this.employeeOption.find(x => x.value === el && x.value !== this.task.assigneeId)
                    if (result) this.selectedColloborators.push(result)
                })
            } else {
                this.selectedColloborators = []
            }
            this.selectedLabel = []
            if (this.task.labels.length > 0) {
                this.task.labels.forEach(el => {
                    let result = this.taskLabel.find(x => x.label === el)
                    if (result) this.selectedLabel.push(result)
                })
            }
            this.task.taskChecklists.forEach(el => {
                el.check = el.status === 2
            })
            this.selectedStatusTask = this.task.status
            this.popupUpdate = true;
            setTimeout(async () => {
                let background = document.getElementById('popup-update-task')
                if (background) {
                    let backgroundUpdate = background.querySelector('.vs-popup--background')
                    if (backgroundUpdate) background.removeChild(backgroundUpdate)
                }
            }, 500)
        },
        getEmployee() {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                this.$crm.get(`/project/get-project-employees/${this.task.project.id}`).then((response) => {
                    this.$vs.loading.close();
                    if (response.data && response.data.length > 0) {
                        this.employeeOption = response.data.map(el => {
                            return {
                                value: el.employeeId,
                                label: el.fullName,
                            }
                        })
                    }
                    resolve(response)
                }).catch(err => {
                    reject(err)
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        title: 'Lỗi',
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',

                    });

                })
            })
        },

        changeColloborator() {
            this.task.collaborators = []
            this.selectedColloborators.forEach(el => {
                this.task.collaborators.push(el.value)
            })
        },

        showPopupCommentTask() {
            this.taskContent = null
            this.fileCmt = []
            this.popupCommentTask = true
            setTimeout(async () => {
                let background = document.getElementById('popup-comment-task')
                if (background) {
                    let backgroundCmt = background.querySelector('.vs-popup--background')
                    if (backgroundCmt) background.removeChild(backgroundCmt)
                }
                await this.getListCommentTask(false)
                await this.getRecentActivityCmt(false)
            }, 500)
        },

        uploadFileCmt() {
            let file = this.$refs.fileCmt.files
            this.fileCmt.push(...file);
            this.$refs.fileCmt.value = null
        },

        postComment() {
            if (!this.taskContent || this.taskContent.trim().length === 0) {
                return this.$vs.notify({
                    text: 'Nội dung bình luận là bắt buộc!',
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                })
            }
            this.$vs.loading()
            let payload = {
                taskId: this.task.id,
                content: this.taskContent
            }

            let formData = new FormData(),
                config = {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    },
                };
            this.fileCmt.forEach(el => formData.append('files', el))
            const blob = new Blob([JSON.stringify(payload)], {type: 'application/json'})
            formData.append('dto', blob);
            this.$crm.post('/task/response/create', formData, config).then(res => {
                this.$vs.loading.close()
                this.$vs.notify({
                    text: 'Bình luận thành công!',
                    color: 'success',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                })
                this.taskContent = null
                let data = res.data
                if (data.fileManagers.length > 0) {
                    data.fileManagers = data.fileManagers.map(el => {
                        el.metaData = JSON.parse(el.metaData)
                    })
                }
                this.dataCommentTask.unshift(data)
            }).catch(err => {
                this.$vs.loading.close()
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                })
            })
        },

        deleteFile(ind) {
            this.fileCmt.splice(ind, 1)
        },

        getListCommentTask(isScroll) {
            return new Promise((resolve, reject) => {
                let payload = {
                    page: this.pageNumberCmt,
                    pageSize: 10,
                    projectId: this.task.project.id,
                    taskId: this.task.id,
                }

                this.$vs.loading()
                this.$crm.post('/task/response/find-by-condition', payload).then(res => {
                    if (res.data.content && res.data.content.length > 0) {
                        if (isScroll) {
                            let data = res.data.content.map(el => {
                                el.createdDateStr = moment(el.createdDate).format('DD/MM/YYYY HH:mm:ss')
                                if (el.fileManagers.length > 0) {
                                    el.fileManagers = el.fileManagers.map(x => {
                                        x.metaData = JSON.parse(x.metaData)
                                        return x
                                    })
                                }
                                return el
                            })
                            this.dataCommentTask.push(...data)
                        } else {
                            this.dataCommentTask = res.data.content.map(el => {
                                el.createdDateStr = moment(el.createdDate).format('DD/MM/YYYY HH:mm:ss')
                                if (el.fileManagers.length > 0) {
                                    el.fileManagers = el.fileManagers.map(x => {
                                        x.metaData = JSON.parse(x.metaData)
                                        return x
                                    })
                                }
                                return el
                            })
                        }
                    } else {
                        this.dataCommentTask = []
                    }
                    this.disableScrollCmt = this.dataCommentTask.length < res.data.totalElements
                    resolve(res)
                    this.$vs.loading.close()
                }).catch(err => {
                    reject(err)
                    this.$vs.loading.close()
                    return this.$vs.notify({
                        title: 'Lỗi',
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                    })
                })
            })
        },

        confirmDeleteTask() {
            let array = this.task.title.split(':')
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận xóa`,
                text: `Bạn có chắc là muốn xóa ${array[0]} không?`,
                accept: this.deleteTask,
                acceptText: "Xóa",
                cancelText: "Huỷ"

            })
        },

        deleteTask() {
            this.$vs.loading()
            this.$crm.delete(`/task/delete/${this.task.id}`).then(() => {
                this.$vs.loading.close()
                this.$vs.notify({
                    text: 'Xóa nhiệm vụ thành công!',
                    color: 'success',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                })
                this.$store.commit('UPDATE_TASK_KANBAN', true)
            }).catch(err => {
                this.$vs.loading.close()
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                })
            })
        },

        confirmDeleteCmt(cmt, index) {
            this.taskContent = null
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận xóa`,
                text: `Bạn có chắc là muốn xóa bình luận này không?`,
                accept: () => this.deleteComment(cmt, index),
                acceptText: "Xóa",
                cancelText: "Huỷ"

            })
        },

        deleteComment(cmt, index) {
            this.$vs.loading()
            this.$crm.delete(`/task/response/delete/${cmt.id}`).then(() => {
                this.$vs.loading.close()
                this.$vs.notify({
                    text: 'Xóa nhiệm vụ thành công!',
                    color: 'success',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                })
                this.dataCommentTask.splice(index, 1)
            }).catch(err => {
                this.$vs.loading.close()
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                })
            })
        },

        closePopup() {
            this.popupCommentTask = false
            this.popupSubTask = false
            this.popupUpdate = false
            this.isAddSubtask = false
            this.isCreateChecklist = false
            this.$store.commit('UPDATE_TASK_KANBAN', true);
        },

        getRecentActivityCmt(isScroll) {
            let body = {
                page: this.pageNumberHis,
                pageSize: 10,
                projectId: this.task.project.id,
                taskId: this.task.id
            }

            this.$vs.loading();
            this.$crm.post(`/task/log-history/find-by-condition`, body).then((response) => {
                this.$vs.loading.close();
                if (response.data.content && response.data.content.length > 0) {
                    if (isScroll) {
                        let data = response.data.content.map(el => {
                            el.metaData = JSON.parse(el.metaData);
                            return el;
                        })
                        this.taskLogHistory.push(...data)
                    } else {
                        this.taskLogHistory = response.data.content.map(el => {
                            el.metaData = JSON.parse(el.metaData);
                            return el;
                        })
                    }
                } else {
                    this.taskLogHistory = []
                }
                this.disableScrollHis = this.taskLogHistory.length < response.data.totalElements
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
            })
        },

        handleScrollActivity(evt) {
            const {scrollTop, offsetHeight, scrollHeight} = evt.target
            if (((scrollTop + offsetHeight) >= scrollHeight) && this.disableScrollHis) {
                this.pageNumberHis = this.pageNumberHis + 1;
                this.getRecentActivityCmt(true);
            }
        },

        handleScrollComment(evt) {
            const {scrollTop, offsetHeight, scrollHeight} = evt.target
            if (((scrollTop + offsetHeight) >= scrollHeight) && this.disableScrollCmt) {
                this.pageNumberCmt = this.pageNumberCmt + 1;
                this.getListCommentTask(true);
            }
        },

        openFile(file) {
            window.open(file.url, '_blank')
        },

        showPopupSubTask() {
            this.selectedStatusTask = this.task.status
            this.popupSubTask = true
            setTimeout(async () => {
                let background = document.getElementById('popup-sub-task')
                if (background) {
                    let backgroundSub = background.querySelector('.vs-popup--background')
                    if (backgroundSub) background.removeChild(backgroundSub)
                }
            }, 500)
        },

        saveSubTask() {
            if (!this.subTaskTitle || this.subTaskTitle.trim().length === 0) {
                return this.$vs.notify({
                    text: 'Tiêu đề nhiệm vụ là bắt buộc!',
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                })
            }
            let payload = {
                title: this.subTaskTitle,
                status: this.task.status,
                startTime: this.task.startTime,
                endTime: this.task.endTime,
                assigneeId: this.task.assigneeId,
                projectId: this.task.project.id,
                priority: this.task.priority,
                id: this.task.id
            }

            this.$vs.loading()
            this.$crm.post(`/task/create-sub-task/${this.task.id}`, payload).then(() => {
                this.$vs.loading.close()
                this.subTaskTitle = null
                this.$vs.notify({
                    color: 'success',
                    text: `Tạo mới thành công`,
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                })
            }).catch(err => {
                this.$vs.loading.close()
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                })
            })
        },

        cancelAddSubtask() {
            this.subTaskTitle = null
            this.isAddSubtask = false
        },

        endDrag() {
            this.drag = false
            this.task.taskChecklists.forEach((el, index) => {
                return el.orders = index;
            });

            this.$vs.loading()
            this.$crm.post(`/task/checklist/update-order/${this.task.id}`, this.task.taskChecklists).then(() => {
                this.$vs.loading.close()
            }).catch(err => {
                this.$vs.loading.close()
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                })
            })
        },

        createChecklistTask() {
            if (!this.checklistTitle || this.checklistTitle.trim().length === 0) {
                return this.$vs.notify({
                    text: 'Tiêu đề danh mục là bắt buộc!',
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                })
            }
            let payload = {
                orders: this.task.taskChecklists.length,
                status: 1,
                taskId: this.task.id,
                title: this.checklistTitle
            }

            this.$vs.loading()
            this.$crm.post('/task/checklist/create', payload).then(res => {
                this.$vs.loading.close()
                this.$vs.notify({
                    color: 'success',
                    text: `Tạo mới thành công`,
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                })
                let data = res.data
                data.check = false
                this.task.taskChecklists.push(data)
                this.checklistTitle = null
            }).catch(err => {
                this.$vs.loading.close()
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                })
            })
        },

        cancelCreateChecklist() {
            this.checklistTitle = null
            this.isCreateChecklist = false
        },

        deleteChecklist(list, ind) {
            this.$vs.loading()
            this.$crm.delete(`/task/checklist/delete/${list.id}`).then(() => {
                this.$vs.loading.close()
                this.$vs.notify({
                    color: 'success',
                    text: `Xóa thành công`,
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                })
                this.task.taskChecklists.splice(ind, 1)
            }).catch(err => {
                this.$vs.loading.close()
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                })
            })
        },

        tickChecklist(list, ind) {
            let payload = {
                id: list.id,
                orders: list.orders,
                status: list.check ? 2 : 1,
                taskId: list.taskId,
                title: list.title
            }
            this.$vs.loading()
            this.$crm.post(`/task/checklist/update-status/${list.id}`, payload).then(() => {
                this.$vs.loading.close()
            }).catch(err => {
                this.$vs.loading.close()
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                })
            })
        }
    },

    computed: {
        validateForm() {
            return !this.errors.any()
        },

        badgeColor() {
            const mappings = {
                Design: "purple",
                "Feature Request": "teal",
                Backend: "blue",
                QA: "green",
                default: "teal"
            };
            return mappings[this.task.type] || mappings.default;
        },

        chipColor() {
            return (value) => {
                switch (value) {
                    case 1:
                        return "primary";
                    case 2:
                        return "warning";
                }
            }
        },

        chipColorStatus() {
            return (value) => {
                switch (value) {
                    case 0:
                        return "rgba(var(--vs-warning), 1)";
                    case 1:
                        return "rgba(1, 119, 253, 1)";
                    case 2:
                        return "rgba(var(--vs-success), 1)";
                    case 3:
                        return "rgba(var(--vs-danger), 1)";
                }
            }
        },

        stringStatus() {
            return (value) => {
                switch (value) {
                    case 0:
                        return "To do";
                    case 1:
                        return "Doing";
                    case 2:
                        return "Completed";
                    case 3:
                        return "Canceled";
                }
            }
        },

        dragOptions() {
            return {
                animation: 200,
                group: "description",
                disabled: false,
                ghostClass: "ghost"
            };
        }
    },

};
</script>
<style scoped>
.required::after {
    content: '*';
    color: red;
}
</style>

<style lang="scss">

#popup-comment-task {
    background: rgba(0, 0, 0, .4);

    .vs-popup {
        width: 1000px !important;
    }

    .scroll--list-file-upload {
        max-height: 100px;
    }

    .scroll--list-comment-task,
    .scroll-area--task-his {
        max-height: 300px;
    }

    .box-title {
        position: relative;
        margin: -15px 15px 10px;
        text-align: center;
        font-weight: 700;
    }

    .box-title:after {
        content: '';
        width: 100%;
        height: 1px;
        display: inline-block;
        position: absolute;
        top: 10px;
        left: 0;
    }
}

.con-vs-dialog {
    z-index: 55000 !important;
}

#popup-update-task {
    background: rgba(0, 0, 0, .4);

    .vs-popup {
        width: 1000px !important;
    }

    .ql-editor {
        max-height: 200px;
    }

    .checklist-task {
        border: 1px dashed #dbdade;
        border-radius: 0.375rem;
        padding: 0.75rem;

        .scroll-area--checklist-task {
            max-height: 300px;

            .item-select {
                border: 1px solid #dbdade;
                border-radius: 0.375rem;
            }
        }
    }
}

#popup-sub-task {
    background: rgba(0, 0, 0, .4);
}

.sub-task {
    border: 1px solid #dbdade;
    border-radius: 0.375rem;
}
</style>
